import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';

// Single accessor for the Gen 2 `amplify_outputs.json` (src/, gitignored — CRA
// forbids imports from outside src/, so the Hosting build writes it there via
// `ampx pipeline-deploy --outputs-out-dir src`; for local dev run
// `npx ampx generate outputs --branch gen2-preview --app-id d2hpmslsxzrk8 --out-dir src`).
// Everything that needs backend config goes through here so a future shape
// change is a one-file edit — do NOT import amplify_outputs.json elsewhere.

interface RestApiEntry {
  endpoint: string;
  region: string;
  apiName: string;
}

interface CustomOutputs {
  API?: Record<string, RestApiEntry>;
  envId?: string;
}

const custom: CustomOutputs =
  (outputs as { custom?: CustomOutputs }).custom ?? {};

// REST APIs keyed by their bare Gen 1 names (mcpProxyApi, erodeapi, …) —
// emitted by amplify/api/*/resource.ts via backend.addOutput.
export const restApis: Record<string, RestApiEntry> = custom.API ?? {};

export function getApiEndpoint(apiName: string): string | null {
  return restApis[apiName]?.endpoint ?? null;
}

// GCS chat-artifact prefix. Must match the mcpProxy Lambda's ENV (= deployed
// branch name). Not derivable from endpoints: Gen 2 API stages are all "prod".
export const envId: string = custom.envId ?? 'dev';

export function configureAmplify(): void {
  // aws-amplify v6 understands the Gen 2 outputs shape natively for
  // auth/data/storage; custom REST APIs must be wired in explicitly.
  Amplify.configure(outputs);
  const current = Amplify.getConfig();
  Amplify.configure({
    ...current,
    API: {
      ...current.API,
      REST: { ...current.API?.REST, ...restApis },
    },
  });
}
